module.exports = __webpack_public_path__ + "img/customer-logos.a09aad9d.png";